(() => {
  const form = document.querySelector('[data-cart-form]');
  if (!form) return;
  const update = form.querySelector('[data-update]');
  const status = form.querySelector('[data-cart-status]');
  const submitUpdate = () => { if (form.reportValidity()) form.requestSubmit(update); };
  form.querySelectorAll('[data-quantity]').forEach(group => {
    const input = group.querySelector('input');
    group.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
      const current = Number(input.value);
      if (!Number.isInteger(current) || current < 1) { input.reportValidity(); return; }
      input.value = Math.max(1, current + Number(button.dataset.step));
      submitUpdate();
    }));
    input.addEventListener('change', submitUpdate);
  });
  form.addEventListener('submit', event => {
    if (event.submitter?.name !== 'update') return;
    status.textContent = 'Actualizando tu cesta…';
    form.querySelectorAll('[data-step]').forEach(button => button.disabled = true);
  });
  update.hidden = true;
})();
